<template>
  <div>
    <div class="form-group text-center relate">
      <form-group id="duvida" label="Alguma dúvida com o conteúdo da aula? Relate aqui e entraremos em contato assim que possível!*" :text="{ required: 'Obrigatório informar a dúvida' }" :field="$v.textoDuvida">
        <textarea class="form-control" id="duvida" rows="4" v-model="textoDuvida"></textarea>
      </form-group>
    </div>
    <div class="text-center">
      <button class="btn btn-primary mt-2 registrar-problema" @click="enviarRelatoDuvida()" :disabled="submit">
        <template v-if="submit">
          <i class="fas fa-spinner fa-spin"></i> Enviando...
        </template>
        <template v-else>
          Enviar
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import RelatoDuvidaAPI from '@/api/relato-duvida-api'
import ResponseUtils from '@/core/utils/response-utils'
import Swal from 'sweetalert2'

export default {
  name: 'RelateUmaDuvida',
  components: { FormGroup },
  props: {
    ementaId: Number
  },
  data () {
    return {
      textoDuvida: '',
      submit: false
    }
  },
  methods: {
    enviarRelatoDuvida: async function () {
      this.$v.textoDuvida.$touch()
      if (!this.$v.textoDuvida.$invalid) {
        const loader = this.$loading.show()
        try {
          this.submit = true
          let url = window.location.href
          await RelatoDuvidaAPI.enviarRelatoDuvida(this.ementaId, this.textoDuvida, url)
          loader.hide()
          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Dúvida enviada com sucesso'
          })
          this.textoDuvida = ''
        } catch (error) {
          ResponseUtils.handleError(error, loader)
        }
        this.submit = false
        this.$v.$reset()
      }
    }
  },
  validations: {
    textoDuvida: { required }
  }
}
</script>

<style scoped>

</style>
